import type { PickerForest } from '@/entities/optimization-group'
import type { OptimizationGroupModel } from '@/shared/generated'

import { uniq } from 'lodash/fp'

import {
	nodeId,
	selectionFromMapping,
	toLegacyLeafIds,
} from '@/entities/optimization-group'

/**
 * Per OG: ids of fully selected PGs plus legacy `${pgId}|${catId}` leaf ids.
 * Feeds the OG list `product_groups` tree filter.
 */
export const getProductGroupsMapByOgId = (
	groups: OptimizationGroupModel[],
	pickerForest: PickerForest
) => {
	const productGroupsMap: Record<string, string[]> = {}
	for (const group of groups) {
		const selection = selectionFromMapping(pickerForest, group.product_groups)
		const pgIds = [...selection.roots]
			.map((root) => nodeId.parse(root))
			.filter((parsed) => parsed.catId === undefined)
			.map((parsed) => parsed.pgId)
		productGroupsMap[group.id] = uniq([
			...pgIds,
			...toLegacyLeafIds(pickerForest, selection),
		])
	}

	return productGroupsMap
}
